import { render, staticRenderFns } from "./RegistrationStepsBox.vue?vue&type=template&id=7cdde2a7&functional=true"
import script from "./RegistrationStepsBox.vue?vue&type=script&lang=js"
export * from "./RegistrationStepsBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports